module.exports = __webpack_public_path__ + "static/media/Screenshot11.4c757eea.jpg";